/* @flow */

import { message } from '~/common';

export const SOLVE_ADDRESS_REQUEST = 'SOLVE_ADDRESS_REQUEST';
export const SOLVE_ADDRESS_SUCCESS = 'SOLVE_ADDRESS_SUCCESS';
export const SOLVE_ADDRESS_FAILURE = 'SOLVE_ADDRESS_FAILURE';

export function success(payload) {
  message.success('Pendência de endereço resolvida');
  return (dispatch) => {
    dispatch({
      type: SOLVE_ADDRESS_SUCCESS,
      payload,
    });
  };
}

// So mostra o texto do servidor quando ele vem com errorCode (ex.: INVALID_ZIP_CODE): os demais
// erros do ajax legado trazem texto tecnico ou o generico 'Erro desconhecido.'.
const serverMessage = (resource) => (resource?.errorCode ? resource?.messages?.[0]?.text : undefined);

export function failure(resource) {
  message.error(serverMessage(resource) || 'Falha ao resolver pendência');
  return (dispatch) => {
    dispatch({
      type: SOLVE_ADDRESS_FAILURE,
      payload: resource,
    });
  };
}

export default function updateConsigneeStatus(params) {
  return (dispatch) => {
    dispatch({
      type: SOLVE_ADDRESS_REQUEST,
      payload: params,
    });
  };
}
